export const BANNER_HEIGHT_DESKTOP = 240;
export const BANNER_HEIGHT_TABLET = 190;
export const BANNER_HEIGHT_MOBILE = 120;
